import { Stack, Typography } from '@mui/material';
import logo from './statics/logo.png';

export default function Logo() {
  return (
    <Stack direction="row">
      <img src={logo} alt="logo" />
      <Typography sx={{
        color: 'black', fontWeight: 700, margin: 'auto', marginLeft: 2,
      }}
      >
        تام
      </Typography>
    </Stack>
  );
}
